import { render } from "./App.vue?vue&type=template&id=e6b3a07e"
const script = {}

import "./App.vue?vue&type=style&index=0&id=e6b3a07e&lang=scss"

import exportComponent from "/Users/hunkyfoxx/Documents/Projects/MarieTenn/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__